import { render, staticRenderFns } from "./rtu.vue?vue&type=template&id=1f35b65d&scoped=true&"
import script from "./rtu.vue?vue&type=script&lang=js&"
export * from "./rtu.vue?vue&type=script&lang=js&"
import style0 from "./rtu.vue?vue&type=style&index=0&id=1f35b65d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f35b65d",
  null
  
)

export default component.exports